<template>
     <div class="bg-[#23242A] text-white app-header p-4 custom">
        <div class="custom-full custom-left">
        <div class="mt-2">
          <div class="flex justify-between shadow-xl box-border items-center text-white h-[76px] rounded p-4 bg-[#2B2C32]  mb-4">
            <h2 class="font-bold text-2xl leading-[30px] tracking-[0.05px]">Transfer Report</h2>
             <buttton @click="exportFile" class="h-[44px] py-2 px-4 cursor-pointer flex justify-center hover:opacity-60 items-center bg-white rounded-md font-medium text-sm leading-[17.5px] tracking-[1.2px] text-[#2BA66B]">Export</buttton>
        </div>
        <div class="flex flex-col justify-start shadow-xl box-border  text-white h-full rounded p-4 bg-[#2B2C32] mb-2">
         
           <div class="flex items-end  xl:flex-row flex-col gap-3 mt-3 mb-3">
           
            <div class="xl:w-1/4 w-full">
              <div class="flex flex-col re-date" :class="'input-wrapper ' + (filter.fromDate.error_type)">
                <label class="mb-0 text-xs">Start Date *</label>
                <div class="relative justify-center align-center input-clear">
                  <svg
                    width="16"
                    class="absolute z-[99] left-[10px] bottom-[12px]"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 10.6667C7.76389 10.6667 7.56597 10.5869 7.40625 10.4272C7.24653 10.2674 7.16667 10.0695 7.16667 9.83342C7.16667 9.5973 7.24653 9.39939 7.40625 9.23967C7.56597 9.07994 7.76389 9.00008 8 9.00008C8.23611 9.00008 8.43403 9.07994 8.59375 9.23967C8.75347 9.39939 8.83333 9.5973 8.83333 9.83342C8.83333 10.0695 8.75347 10.2674 8.59375 10.4272C8.43403 10.5869 8.23611 10.6667 8 10.6667ZM4.66667 10.6667C4.43056 10.6667 4.23264 10.5869 4.07292 10.4272C3.91319 10.2674 3.83333 10.0695 3.83333 9.83342C3.83333 9.5973 3.91319 9.39939 4.07292 9.23967C4.23264 9.07994 4.43056 9.00008 4.66667 9.00008C4.90278 9.00008 5.10069 9.07994 5.26042 9.23967C5.42014 9.39939 5.5 9.5973 5.5 9.83342C5.5 10.0695 5.42014 10.2674 5.26042 10.4272C5.10069 10.5869 4.90278 10.6667 4.66667 10.6667ZM11.3333 10.6667C11.0972 10.6667 10.8993 10.5869 10.7396 10.4272C10.5799 10.2674 10.5 10.0695 10.5 9.83342C10.5 9.5973 10.5799 9.39939 10.7396 9.23967C10.8993 9.07994 11.0972 9.00008 11.3333 9.00008C11.5694 9.00008 11.7674 9.07994 11.9271 9.23967C12.0868 9.39939 12.1667 9.5973 12.1667 9.83342C12.1667 10.0695 12.0868 10.2674 11.9271 10.4272C11.7674 10.5869 11.5694 10.6667 11.3333 10.6667ZM8 14.0001C7.76389 14.0001 7.56597 13.9202 7.40625 13.7605C7.24653 13.6008 7.16667 13.4029 7.16667 13.1667C7.16667 12.9306 7.24653 12.7327 7.40625 12.573C7.56597 12.4133 7.76389 12.3334 8 12.3334C8.23611 12.3334 8.43403 12.4133 8.59375 12.573C8.75347 12.7327 8.83333 12.9306 8.83333 13.1667C8.83333 13.4029 8.75347 13.6008 8.59375 13.7605C8.43403 13.9202 8.23611 14.0001 8 14.0001ZM4.66667 14.0001C4.43056 14.0001 4.23264 13.9202 4.07292 13.7605C3.91319 13.6008 3.83333 13.4029 3.83333 13.1667C3.83333 12.9306 3.91319 12.7327 4.07292 12.573C4.23264 12.4133 4.43056 12.3334 4.66667 12.3334C4.90278 12.3334 5.10069 12.4133 5.26042 12.573C5.42014 12.7327 5.5 12.9306 5.5 13.1667C5.5 13.4029 5.42014 13.6008 5.26042 13.7605C5.10069 13.9202 4.90278 14.0001 4.66667 14.0001ZM11.3333 14.0001C11.0972 14.0001 10.8993 13.9202 10.7396 13.7605C10.5799 13.6008 10.5 13.4029 10.5 13.1667C10.5 12.9306 10.5799 12.7327 10.7396 12.573C10.8993 12.4133 11.0972 12.3334 11.3333 12.3334C11.5694 12.3334 11.7674 12.4133 11.9271 12.573C12.0868 12.7327 12.1667 12.9306 12.1667 13.1667C12.1667 13.4029 12.0868 13.6008 11.9271 13.7605C11.7674 13.9202 11.5694 14.0001 11.3333 14.0001ZM1.75 17.3334C1.41667 17.3334 1.125 17.2084 0.875 16.9584C0.625 16.7084 0.5 16.4167 0.5 16.0834V3.16675C0.5 2.83341 0.625 2.54175 0.875 2.29175C1.125 2.04175 1.41667 1.91675 1.75 1.91675H3.10417V0.666748H4.45833V1.91675H11.5417V0.666748H12.8958V1.91675H14.25C14.5833 1.91675 14.875 2.04175 15.125 2.29175C15.375 2.54175 15.5 2.83341 15.5 3.16675V16.0834C15.5 16.4167 15.375 16.7084 15.125 16.9584C14.875 17.2084 14.5833 17.3334 14.25 17.3334H1.75ZM1.75 16.0834H14.25V7.12508H1.75V16.0834ZM1.75 5.87508H14.25V3.16675H1.75V5.87508ZM1.75 5.87508V3.16675V5.87508Z"
                      fill="white"
                    />
                  </svg>
                  
                  <Datepicker
                    inputFormat="yyyy-MM-dd"
                    :clearable="true"
                    v-model="filter.fromDate.value"
                    :class="filter.fromDate.value?'text-[#fff]':'text-[#9E9E9E]'"
                    class="h-[40px] rounded-md bg-gray-black w-full border-none text-base leading-5 pl-[34px]"
                    placeholder="Select a Date"
                  />
                </div>
                <p class="field-error label-text mt-1" v-if="filter.fromDate.error_message" v-text="filter.fromDate.error_message"></p>
                <p class="label-text mt-1" v-else>&nbsp;</p>
              </div>
            </div>
            <div class="xl:w-1/4 w-full">
              <div class="flex flex-col re-date" :class="'input-wrapper ' + (filter.toDate.error_type)">
                <label class="mb-0 text-xs">End Date *</label>
                <div class="relative justify-center align-center input-clear">
                  <svg
                    width="16"
                    class="absolute z-[99] left-[10px] bottom-[12px]"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 10.6667C7.76389 10.6667 7.56597 10.5869 7.40625 10.4272C7.24653 10.2674 7.16667 10.0695 7.16667 9.83342C7.16667 9.5973 7.24653 9.39939 7.40625 9.23967C7.56597 9.07994 7.76389 9.00008 8 9.00008C8.23611 9.00008 8.43403 9.07994 8.59375 9.23967C8.75347 9.39939 8.83333 9.5973 8.83333 9.83342C8.83333 10.0695 8.75347 10.2674 8.59375 10.4272C8.43403 10.5869 8.23611 10.6667 8 10.6667ZM4.66667 10.6667C4.43056 10.6667 4.23264 10.5869 4.07292 10.4272C3.91319 10.2674 3.83333 10.0695 3.83333 9.83342C3.83333 9.5973 3.91319 9.39939 4.07292 9.23967C4.23264 9.07994 4.43056 9.00008 4.66667 9.00008C4.90278 9.00008 5.10069 9.07994 5.26042 9.23967C5.42014 9.39939 5.5 9.5973 5.5 9.83342C5.5 10.0695 5.42014 10.2674 5.26042 10.4272C5.10069 10.5869 4.90278 10.6667 4.66667 10.6667ZM11.3333 10.6667C11.0972 10.6667 10.8993 10.5869 10.7396 10.4272C10.5799 10.2674 10.5 10.0695 10.5 9.83342C10.5 9.5973 10.5799 9.39939 10.7396 9.23967C10.8993 9.07994 11.0972 9.00008 11.3333 9.00008C11.5694 9.00008 11.7674 9.07994 11.9271 9.23967C12.0868 9.39939 12.1667 9.5973 12.1667 9.83342C12.1667 10.0695 12.0868 10.2674 11.9271 10.4272C11.7674 10.5869 11.5694 10.6667 11.3333 10.6667ZM8 14.0001C7.76389 14.0001 7.56597 13.9202 7.40625 13.7605C7.24653 13.6008 7.16667 13.4029 7.16667 13.1667C7.16667 12.9306 7.24653 12.7327 7.40625 12.573C7.56597 12.4133 7.76389 12.3334 8 12.3334C8.23611 12.3334 8.43403 12.4133 8.59375 12.573C8.75347 12.7327 8.83333 12.9306 8.83333 13.1667C8.83333 13.4029 8.75347 13.6008 8.59375 13.7605C8.43403 13.9202 8.23611 14.0001 8 14.0001ZM4.66667 14.0001C4.43056 14.0001 4.23264 13.9202 4.07292 13.7605C3.91319 13.6008 3.83333 13.4029 3.83333 13.1667C3.83333 12.9306 3.91319 12.7327 4.07292 12.573C4.23264 12.4133 4.43056 12.3334 4.66667 12.3334C4.90278 12.3334 5.10069 12.4133 5.26042 12.573C5.42014 12.7327 5.5 12.9306 5.5 13.1667C5.5 13.4029 5.42014 13.6008 5.26042 13.7605C5.10069 13.9202 4.90278 14.0001 4.66667 14.0001ZM11.3333 14.0001C11.0972 14.0001 10.8993 13.9202 10.7396 13.7605C10.5799 13.6008 10.5 13.4029 10.5 13.1667C10.5 12.9306 10.5799 12.7327 10.7396 12.573C10.8993 12.4133 11.0972 12.3334 11.3333 12.3334C11.5694 12.3334 11.7674 12.4133 11.9271 12.573C12.0868 12.7327 12.1667 12.9306 12.1667 13.1667C12.1667 13.4029 12.0868 13.6008 11.9271 13.7605C11.7674 13.9202 11.5694 14.0001 11.3333 14.0001ZM1.75 17.3334C1.41667 17.3334 1.125 17.2084 0.875 16.9584C0.625 16.7084 0.5 16.4167 0.5 16.0834V3.16675C0.5 2.83341 0.625 2.54175 0.875 2.29175C1.125 2.04175 1.41667 1.91675 1.75 1.91675H3.10417V0.666748H4.45833V1.91675H11.5417V0.666748H12.8958V1.91675H14.25C14.5833 1.91675 14.875 2.04175 15.125 2.29175C15.375 2.54175 15.5 2.83341 15.5 3.16675V16.0834C15.5 16.4167 15.375 16.7084 15.125 16.9584C14.875 17.2084 14.5833 17.3334 14.25 17.3334H1.75ZM1.75 16.0834H14.25V7.12508H1.75V16.0834ZM1.75 5.87508H14.25V3.16675H1.75V5.87508ZM1.75 5.87508V3.16675V5.87508Z"
                      fill="white"
                    />
                  </svg>
                  
                  <Datepicker
                    inputFormat="yyyy-MM-dd"
                    :clearable="true"
                    v-model="filter.toDate.value"
                    :class="filter.toDate.value?'text-[#fff]':'text-[#9E9E9E]'"
                    class="h-[40px] rounded-md bg-gray-black w-full border-none text-base leading-5 pl-[34px]"
                    placeholder="Select a Date"
                  />
                </div>
                <p class="field-error label-text mt-1" v-if="filter.toDate.error_message" v-text="filter.toDate.error_message"></p>
                <p class="label-text mt-1" v-else>&nbsp;</p>
              </div>
            </div>

            <div class="xl:w-1/4 w-full">
              <div :class="'input-wrapper relative ' + (filter.shipFromLocationId.error_type)">
                <label class="mb-0 text-xs">Ship from Location</label>
                <SelectLocation
                  class="bg-gray-black rounded relative"
                  classValue="top-10"
                  v-model="filter.shipFromLocationId.value"
                  :options="vg_locations"
                  placeholder="Select One"
                />
                <p class="field-error label-text mt-1" v-if="filter.shipFromLocationId.error_message" v-text="filter.shipFromLocationId.error_message"></p>
                <p class="label-text mt-1" v-else>&nbsp;</p>
              </div>
            </div>
            <div class="xl:w-1/4 w-full">
              <div :class="'input-wrapper relative ' + (filter.shipToLocationId.error_type)">
                <label class="mb-0 text-xs">Ship to Location</label>
                <SelectLocation
                  class="bg-gray-black rounded relative"
                  classValue="top-10"
                  v-model="filter.shipToLocationId.value"
                  :options="vg_locations"
                  placeholder="Select One"
                />
                <p class="field-error label-text mt-1" v-if="filter.shipToLocationId.error_message" v-text="filter.shipToLocationId.error_message"></p>
                <p class="label-text mt-1" v-else>&nbsp;</p>
              </div>
            </div>

            <div class="xl:w-1/4 w-full">
                <div :class="'input-wrapper flex flex-col ' + filter.transferName.error_type">
                  <label class="mb-0 text-xs">Transfer #</label>
                  <input
                    v-model="filter.transferName.value"
                    :class="' h-[40px] flex justify-start items-center placeholder-[#9E9E9E] rounded-md bg-gray-black w-full border-none text-base leading-5 p-2'"
                    placeholder="Enter order #"
                    type="text"
                  />
                  <p
                    class="field-error label-text mt-1"
                    v-if="filter.transferName.error_message"
                    v-text="filter.transferName.error_message"
                  ></p>
                  <p class="field-error label-text mt-1" v-else>&nbsp;</p>
                </div>
            </div>
          </div>

          <div class="input-wrapper">
            <label class="font-normal text-xs leading-5 mb-3 tracking-[0.15px]">Export File Format</label>
            <div class="flex items-center mt-2">
              <input
                checked
                id="format"
                value="csv"
                type="radio"
                name="no_reward"
                class="w-4 h-4 bg-transparent border-2 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              />
              <label
                for="format"
                class="ml-2 text-base leading-5 font-normal tracking-wider text-white dark:text-gray-300"
                >XLSX</label
              >
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref } from 'vue'
import Datepicker from 'vue3-datepicker'
import SelectLocation from '@/components/form/SelectLocation'
import SelectCheckbox from '@/components/form/SelectCheckbox.vue'
import { mapGetters, mapMutations } from 'vuex'
import { useSnackbar } from "vue3-snackbar"
import Helpers from '@/helpers';
import ReportHelpers from '@/helpers/report'
import ProductApi from '@/controllers/BusinessProductApis'
import ReportApis from '@/controllers/ReportApis'
import moment from 'moment-timezone'
import writeXlsxFile from 'write-excel-file';

export default defineComponent({
  components: {
    Datepicker,
    SelectLocation,
    SelectCheckbox
  },
  setup() {
    const snackbar = useSnackbar();
    const taxOptions = ref([])
    const filter = ref({
      fromDate: {
        value: null,
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      toDate: {
        value: null,
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      shipFromLocationId: {
        value: '',
        error_type: '',
        error_message: '',
        validations: [''],
      },
      shipToLocationId: {
        value: '',
        error_type: '',
        error_message: '',
        validations: [''],
      },
      transferName: {
        value: '',
        error_type: '',
        error_message: '',
        validations: [],
      }
    })
    return {
      snackbar,
      taxOptions,
      filter
    }
  },
  mounted(){
    this.getTaxes()
  },
  computed: {
    ...mapGetters({
      vg_locations: 'location/list',
      vg_selectedBusiness: 'auth/activeBusiness',
      vg_selectedLocation: 'location/selected'
    })
  },
  methods: {
    async getTaxes(){
      let businessId = this.vg_selectedBusiness.id
      let res = await ProductApi.fetchAllTaxes(businessId)
      if(res.data?.payload){
        let taxes = res.data.payload
        this.taxOptions = taxes.map(each => {return {id: each.id, name:each.code}})
      }
    },
    async validateFields(fields) {
        let res = await Helpers.validateFormFields(this.filter, fields);
        // capture the fields
        this.form = res.data;
        return res.error ? false : true;
    },
    async exportFile(){
      let validate = await this.validateFields(['fromDate', 'toDate', 'shipFromLocationId', 'shipToLocationId']);
      if(!validate) {
          return ;
      }
      let data = Helpers.getFormKeyValue(this.filter)
      data.fromDate = moment(this.filter.fromDate.value).format('YYYY-MM-DD');
      data.toDate = moment(this.filter.toDate.value).format('YYYY-MM-DD');
      this.vm_spinner(true)
      let dataObj = {
        startDate: data.fromDate,
        endDate: data.toDate
      }
      if(data.shipFromLocationId){
        dataObj.shipFromLocationId = data.shipFromLocationId
      }
      if(data.shipToLocationId){
        dataObj.shipToLocationId = data.shipToLocationId
      }
      if(data.transferName){
        dataObj.transferName=data.transferName
      }
      let res = await ReportApis.transferReport(dataObj)
      if(res.status == 200 && res.data.payload.length>0){
        let results = []
        let defaultTimeZone = this.vg_selectedLocation.timezone?this.vg_selectedLocation.timezone:'America/Toronto';
        for(let i=0; i<res.data.payload.length; i++){
            let obj = res.data.payload[i]
            // transfer from
            let transferFrom = ''
            if(obj?.transferProduct?.transfer?.fromLocation?.name){
              transferFrom = obj.transferProduct.transfer.fromLocation.name
            }else if(!obj.transferProduct && obj.reason==='Transfer out'){
              transferFrom = obj.location.name
            }else if(!obj.transferProduct && obj.reason==='Transfer in'){
              transferFrom = obj.counterPartyId
            }
            // transfer to
            let transferTo = ''
            if(obj.transferProduct?.transfer?.toLocation?.name){
              transferTo = obj.transferProduct.transfer.toLocation.name
            }else if(!obj.transferProduct && obj.reason==='Transfer in'){
              transferTo = obj.location.name
            }else if(!obj.transferProduct && obj.reason==='Transfer out'){
              transferTo = obj.counterPartyId
            }

            let newObj = {
                transferName: obj?.transferProduct?.transfer?.name ? obj.transferProduct.transfer.name: "Transfer-"+obj.adjustmentId.toString(),
                transferFrom: transferFrom,
                transferTo: transferTo,
                productName: obj.product?.name ? obj.product.name:'',
                category: obj.product?.category?.name ? obj.product.category.name:'',
                complianceType: obj.product?.complianceType ? obj.product.complianceType:'',
                productQty: obj.adjustment,
                sku: obj.product?.sku ? obj.product.sku:'',
                lotNumber: obj.batchUploadDetail?.batch_lot ? obj.batchUploadDetail.batch_lot:'',
                gtin: obj.product?.barcode ? obj.product.barcode:'',
                startedBy: !obj.transferProduct?obj.createdByName:obj.createdByName,
                completedBy: obj.transferProduct?.transfer?.createdByName ? obj.transferProduct.transfer.createdByName: obj.createdByName,
                status: obj.transferProduct?.transfer?.status ? obj.transferProduct.transfer.status:'completed transfer',
                createdOn: obj.transferProduct?.transfer?.createdAt ? moment(obj.transferProduct.transfer.createdAt).tz(defaultTimeZone).format('YYYY-MM-DD'):moment(obj.createdAt).tz(defaultTimeZone).format('YYYY-MM-DD')
            }
            results.push(newObj)
        }
        this.createXlSheet(results)
      }else{
        this.snackbar.add({
              type: 'info',
              text: 'No Transfer within the selected date range!',
              duration: 3000,
          })
      }
      this.vm_spinner(false)
    },

    async createXlSheet(jsonData) {
      try {
        let schema = [
          {
            column: 'Transfer #',
            type: String,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.transferName ? i.transferName : '' 
          },
          {
            column: 'Transfer From',
            type: String,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.transferFrom ? i.transferFrom : '' 
          },
          {
            column: 'Transfer To',
            type: String,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.transferTo ? i.transferTo : '' 
          },
          {
            column: 'Products Name',
            type: String,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.productName ? i.productName : '' 
          },
          {
            column: 'Category',
            type: String,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.category ? i.category : '' 
          },
          {
            column: 'Compliance type',
            type: String,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.complianceType ? i.complianceType : '' 
          },
          {
            column: 'Products Qty',
            type: Number,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.productQty ? i.productQty : null 
          },
          {
            column: 'SKU',
            type: String,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.sku ? i.sku : '' 
          },
          {
            column: 'Lot Number',
            type: String,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.lotNumber ? i.lotNumber : '' 
          },
          {
            column: 'UPC/GTIN',
            type: String,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.gtin ? i.gtin : '' 
          },
          {
            column: 'Started By',
            type: String,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.startedBy ? i.startedBy : '' 
          },
          {
            column: 'Completed By',
            type: String,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.completedBy ? i.completedBy : '' 
          },
          {
            column: 'Status',
            type: String,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.status ? i.status : '' 
          },
          {
            column: 'Created On',
            type: String,
            wrap: true,
            alignVertical: 'center',
            align: 'center',
            value: i => i.createdOn ? i.createdOn : '' 
          },
        ];

        let widthArr = await ReportHelpers.calculateWidth(schema)
        await ReportHelpers.addWidthToSchema(schema, widthArr)
        let xlBlob = await writeXlsxFile(jsonData, {
          schema: schema,
        });
        let fileName = 'Transfer-Report.xlsx';
        let url = URL.createObjectURL(xlBlob);
        let link = document.createElement("a");
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        let self = this
        setTimeout(function(){
          self.snackbar.add({
            type: 'info',
            text: 'File downloaded',
            duration: 3000,
          })
        }, 1000)
      } catch(err) {
        console.log(err)
        return this.snackbar.add({
          type: 'info',
          text: 'Something went wrong. Please try again later.',
          duration: 3000,
        })
      }
    },
    readableDate(str){
      return str?moment(str, 'YYYY-MM-DD').format('YYYY-MM-DD'):''
    },

    ...mapMutations({
      vm_spinner: 'spinner/mutateSpinner'
    })
  }
})
</script>
